import {
    EDITMERCHANTWIRE_SUCCESS,
    EDITMERCHANTWIRE_FAILED,
    RESET_EDITMERCHANTWIRE,
    LOADING_EDITMERCHANTWIRE,
    NETWORK_ERROR_EDITMERCHANTWIRE
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_EDITMERCHANTWIRE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case EDITMERCHANTWIRE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case EDITMERCHANTWIRE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_EDITMERCHANTWIRE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_EDITMERCHANTWIRE:
            return (state = initialState);
        default:
            return state;
    }
};
